import { useEffect, useState } from 'react';

import { Placeholder } from 'src/components/Placeholder/Placeholder';
import { advertsIsEnabled } from 'src/config';
import { useAppConfig } from 'src/config/appConfig';
import { GooglePublisherTag } from 'src/modules/gpt-react';
import { useSelector } from 'src/store/react';
import { selectGPTTargeting } from 'src/store/results/selectors';

import useHoustonAd from './useHoustonAd';

interface Props {
  height: number;
  minWidth: number;
  tagName: string;
  width: number;
  forceAdRefreshIneligiblity?: boolean;
}

const HoustonAd = ({
  minWidth,
  tagName,
  width,
  height,
  forceAdRefreshIneligiblity,
}: Props) => {
  const targetingData = useSelector(selectGPTTargeting);
  const { shouldRenderAdverts } = useHoustonAd({
    minimumClientWidth: minWidth,
  });
  const { country } = useAppConfig();
  const { GPT_ACCOUNT_ID } = useAppConfig();
  const tagId = `/${GPT_ACCOUNT_ID}/SEEK${country}/${tagName}`;

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  if (shouldRenderAdverts && isClient) {
    return advertsIsEnabled ? (
      <GooglePublisherTag
        tagId={tagId}
        responsiveSizing={[{ sizes: [{ height, width }] }]}
        targetingData={targetingData}
        forceAdRefreshIneligiblity={forceAdRefreshIneligiblity}
      />
    ) : (
      <Placeholder
        width={width}
        height={height}
        label={`Advertisement with Tag ID: ${tagId}`}
        data-automation={`ad-${tagName}`}
      />
    );
  }

  return null;
};

export default HoustonAd;
